import { Icon } from '@chakra-ui/react';

export const Search = (props) => {
  return (
    <Icon width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.21569 11.6814C7.451 11.6814 8.5906 11.2716 9.50594 10.5805L11.9529 13.0275C12.2497 13.3242 12.7307 13.3242 13.0275 13.0275C13.3242 12.7307 13.3242 12.2497 13.0275 11.9529L10.5805 9.50594C11.2716 8.5906 11.6814 7.451 11.6814 6.21569C11.6814 3.19707 9.2343 0.75 6.21569 0.75C3.19707 0.75 0.75 3.19707 0.75 6.21569C0.75 9.2343 3.19707 11.6814 6.21569 11.6814ZM2.26961 6.21569C2.26961 8.39505 4.03633 10.1618 6.21569 10.1618C8.39505 10.1618 10.1618 8.39505 10.1618 6.21569C10.1618 4.03633 8.39505 2.26961 6.21569 2.26961C4.03633 2.26961 2.26961 4.03633 2.26961 6.21569Z"
        fill="currentColor"
      />
    </Icon>
  );
};
